import { Module, VuexModule } from 'vuex-module-decorators';
import { IWritingTask } from '../types/writingTask';

/**
 * This store mainly handles all the data that the web-highlighter package produces and we use in the highlight implementation.
 * When a user interacts with the text in a document, the Note interface will pop up on the righthand side.
 * web-highlighter is a standalone npm package, and this store is supposed to be the 'glue' between that and our real state containing more data.
 */

// We instantiate the highlighter out here to ensure there is only one instance,
// and not an instance for each <SystimeHighlight>

@Module({
  stateFactory: true,
  namespaced: true
})
export default class WritingTaskStore extends VuexModule {
  writingTask: IWritingTask = {
    content: null,
    start: 1,
    openAllTasks: false,
    writingTaskBaseId: '1'
  };
}
